
function SearchBar({ placeholder="Buscar...", value, onChange }) {
  return (
    <div className="cc-toolbar">
      <input className="cc-search" type="text" placeholder={placeholder} value={value} onChange={onChange} />
    </div>
  );
}
export default SearchBar;
